/* eslint react/prop-types:0 */
import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { BetaFeaturesSiteSettingsPageLoader } from '@confluence/beta-features/entry-points/BetaFeaturesSiteSettingsPage.ts';

export const BetaFeaturesRoute = () => <BetaFeaturesSiteSettingsPageLoader />;

BetaFeaturesRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'betaFeaturesScreen' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
